import { PRAXA_PLUS_ICON_PATH, PRAXA_PLUS_ICON_VIEW_BOX } from "@praxa/shared/praxaPlusIcon";
import type { SVGProps } from "react";

export type PraxaPlusIconProps = SVGProps<SVGSVGElement>;

export function PraxaPlusIcon(props: PraxaPlusIconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      height={24}
      preserveAspectRatio="none"
      width={24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox={PRAXA_PLUS_ICON_VIEW_BOX}
    >
      <path d={PRAXA_PLUS_ICON_PATH} fill="currentColor" />
    </svg>
  );
}
